/*
 *
 * DentistDataPage constants
 *
 */
import { getPractice } from "utils/practiceStorage";

/**
 * Get DENTIST
 */
export const GET_DENTIST = "app/DentistDataPage/GET_DENTIST";
export const GET_DENTIST_FAILED = "app/DentistDataPage/GET_DENTIST_FAILED";
export const GET_DENTIST_SUCCESS = "app/DentistDataPage/GET_DENTIST_SUCCESS";
/**
 * Update DENTIST
 */
export const UPDATE_DENTIST = "app/DentistDataPage/UPDATE_DENTIST";
export const UPDATE_DENTIST_FAILED =
  "app/DentistDataPage/UPDATE_DENTIST_FAILED";
export const UPDATE_DENTIST_SUCCESS =
  "app/DentistDataPage/UPDATE_DENTIST_SUCCESS";
/**
 * Delete DENTIST
 */
export const DELETE_DENTIST = "app/DentistDataPage/DELETE_DENTIST";
export const DELETE_DENTIST_FAILED =
  "app/DentistDataPage/DELETE_DENTIST_FAILED";
export const DELETE_DENTIST_SUCCESS =
  "app/DentistDataPage/DELETE_DENTIST_SUCCESS";
/**
 * Other
 */
export const DEFAULT_ACTION = "app/DentistDataPage/DEFAULT_ACTION";

/**
 * Urls
 */

export function UPDATE_DENTIST_URL() {
  return `/practices/${getPractice().id}/dentists`;
}

export function DELETE_DENTIST_URL() {
  return `/practices/${getPractice().id}/dentists`;
}

export function DENTIST_URL(dentistId) {
  return `/practices/${getPractice().id}/dentists/${dentistId}`;
}
